// import { Link } from "react-router-dom";
export default function Home() {
  return (
    <div className="content">
      <h1>Welcome the greate application Home</h1>
    </div>
  );
}
